__turbopack_context__.v({
  "block": "core-module-scss-module__S_ZcWG__block" + " " + "core-module-scss-module__S_ZcWG__core",
  "complete": "core-module-scss-module__S_ZcWG__complete",
  "core": "core-module-scss-module__S_ZcWG__core",
  "medium": "core-module-scss-module__S_ZcWG__medium",
  "playing": "core-module-scss-module__S_ZcWG__playing",
  "responsive-image": "core-module-scss-module__S_ZcWG__responsive-image",
  "small": "core-module-scss-module__S_ZcWG__small",
});
